// src/components/Dashboard/SectionsGrid.tsx
import React from 'react';

const SectionsGrid: React.FC = () => {
  // Данные для карточек можно вынести в props или state при необходимости
  const sections = [
    { icon: '🤖', title: 'Управление роботами', description: 'Просмотр списка роботов и управление ими', link: '#robots' },
    { icon: '📊', title: 'Мониторинг', description: 'Просмотр статистики и состояния роботов', link: '#' },
    { icon: '⚙️', title: 'Настройки', description: 'Конфигурация системы и пользователей', link: '#' },
    { icon: '📝', title: 'Логи', description: 'Просмотр журналов работы системы', link: '#' },
  ];

  return (
    <section className="sections-grid">
      {sections.map((section, index) => (
        <div className="section-card" key={index}>
          <div className="card-icon">{section.icon}</div>
          <h3>{section.title}</h3>
          <p>{section.description}</p>
          <a href={section.link} className="card-link">Перейти →</a>
        </div>
      ))}
    </section>
  );
};

export default SectionsGrid;